module.exports = __webpack_public_path__ + "static/media/chevron-blue.acdd70a5.svg";